import { Box } from '@wix/design-system';
import React, { FC, ReactElement } from 'react';

import { IBotMessage } from '../../../common/messageCreators';
import { AlertIconFilled, FlagIcon, InfoIcon, SuccessIcon, WarningIcon } from '../../icons';

const iconComponent: Record<Required<IBotMessage>['icon'], ReactElement> = {
  flag: (
    <Box color="D20">
      <FlagIcon />
    </Box>
  ),
  info: (
    <Box color="D40">
      <InfoIcon />
    </Box>
  ),
  // NOTE: warning and alert icons are inverted in the builder (at least names)
  // CxD team mostly relies on the icon itself, so we keep it as is
  warning: (
    <Box color="R10">
      <AlertIconFilled />
    </Box>
  ),
  alert: (
    <Box color="Y10">
      <WarningIcon />
    </Box>
  ),
  success: (
    <Box color="G10">
      <SuccessIcon />
    </Box>
  ),
};

export const BotMessageIcon: FC<Pick<IBotMessage, 'icon'>> = ({ icon }) => {
  return (icon && iconComponent[icon]) || null;
};
